import { atom } from 'jotai'

export const _seasons_isometry = atom({
  frames        : {},
  percent       : {},
  status        : {},
  activeframe   : {},
  svgdimensions : {},
  activescale   : {},
  config        : {},
  snapindex     : {},
  imageindex    : {},
  showoverlay   : {},
  mode          : {},
  tiny          : [],
  overlays      : [],
  season_type : {}
})